module.exports = __webpack_public_path__ + "img/no-data.1eb41e33.png";